export default {
  saveSignupSession (state, value) {
    state.signupSession = value
  },
  saveFirstName (state, value) {
    state.firstName = value
  },
  saveLastName (state, value) {
    state.lastName = value
  },
  saveEmail (state, value) {
    state.email = value
  },
  savePassword (state, value) {
    state.password = value
  },
  saveBirthdate (state, value) {
    state.birthdate = value
  },

  saveCountry (state, value) {
    state.country = value
  },
  saveState (state, value) {
    state.state = value
  },
  saveStreetName (state, value) {
    state.streetName = value
  },
  saveCity (state, value) {
    state.city = value
  },
  saveZipCode (state, value) {
    state.zipCode = value
  },

  saveTerms (state, value) {
    state.acceptsTerms = value
  },
  savePrivacy (state, value) {
    state.acceptsPrivacy = value
  },
  saveDivisions (state, value) {
    state.divisions = value
  },
  saveStripeClientSecret (state, value) {
    state.stripeClientSecret = value
  },
  // Guardian data
  saveGuardianFirstName (state, value) {
    state.guardianFirstName = value
  },
  saveGuardianLastName (state, value) {
    state.guardianLastName = value
  },
  saveGuardianEmail (state, value) {
    state.guardianEmail = value
  },
  saveConsent (state, value) {
    state.guardianConsent = value
  },
  saveVideoConsent (state, value) {
    state.guardianVideoConsent = value
  }
}
